import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { ContextLink } from '../../../shared/components/context-link/context-link';
import { useDemographicsFilter } from '../../../shared/hooks/demographic';
import { createStyleHelper } from '../../../shared/utils/class-names';
import { exists } from '../../../shared/utils/filters';
import { slugify } from '../../../shared/utils/strings';
import type { IFooterItem } from '../../queries/footer.graphql';
import { FooterIcon } from '../footer-icon/footer-icon';

import styles from './footer-item.module.scss';

const style = createStyleHelper(styles, 'footer-item');

export interface IFooterProps {
    displayItem?: IFooterItem | null;
}

export const FooterItem: FunctionComponent<IFooterProps> = ({ displayItem }) => {
    const filteredIcons = useDemographicsFilter(displayItem?.icons?.filter(exists) ?? []);

    if (!displayItem) {
        return null;
    }

    return (
        <ContextLink
            className={style('link')}
            rawHref={displayItem?.url?.startsWith('https://')}
            to={displayItem?.url ?? ''}
            target={displayItem?.openInNewTab ? '_blank' : undefined}
            rel={displayItem?.openInNewTab ? 'noopener' : undefined}
        >
            {filteredIcons.length ? (
                <FooterIcon
                    key={displayItem?.id}
                    footerIcons={displayItem?.icons?.filter(exists) ?? []}
                />
            ) : (
                <FormattedMessage
                    id={`footer.link.${slugify(displayItem?.name ?? '')}`}
                    defaultMessage={displayItem?.name ?? ''}
                />
            )}
        </ContextLink>
    );
};
